var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLockPrivacy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.1611 11.5H5.16113C4.05656 11.5 3.16113 12.3954 3.16113 13.5V20.5C3.16113 21.6046 4.05656 22.5 5.16113 22.5H19.1611C20.2657 22.5 21.1611 21.6046 21.1611 20.5V13.5C21.1611 12.3954 20.2657 11.5 19.1611 11.5Z",
    stroke: "#ADADAD",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.16113 11.5V7.5C7.16113 4.73857 9.39971 2.5 12.1611 2.5C14.9225 2.5 17.1611 4.73857 17.1611 7.5V11.5",
    stroke: "#ADADAD",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLockPrivacy);
export default __webpack_public_path__ + "static/media/lock-privacy.0a4711c80c83f82552802da8f6fa7e5d.svg";
export { ForwardRef as ReactComponent };